<div class="restart-modal">
  <div class="restart-modal__header">Form Error</div>
  <div class="restart-modal__content">{{ message }}</div>
  <div class="restart-modal__actions">
    <sl-button type="button" (click)="restartForm()">Restart Form</sl-button>
  </div>
</div>
